module.exports = __webpack_public_path__ + "img/chat-account.ff717983.svg";